import React from 'react';
import { Box, Typography } from '@mui/material';
import { INK, MUTED } from './home/homeTheme';

// Larghezza massima comune delle pagine V2: il titolo parte sempre dallo stesso punto
export const PAGE_MAX_WIDTH = 1480;

/** Contenitore comune delle pagine V2. */
export function PageContainer({ children }) {
  return <Box sx={{ maxWidth: PAGE_MAX_WIDTH, mx: 'auto', pb: 6 }}>{children}</Box>;
}

/**
 * Intestazione comune delle pagine V2: titolo (e sottotitolo) a sinistra, periodo e azioni a destra.
 * Il titolo resta in alto anche quando i controlli a destra sono più alti, così ha la stessa posizione in ogni pagina.
 */
export default function PageHeader({ title, subtitle, children }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', columnGap: 2, rowGap: 1.5, mb: 2.5 }}>
      <Box sx={{ minWidth: 0 }}>
        <Typography component="h1" sx={{ fontSize: { xs: 22, md: 26 }, fontWeight: 800, color: INK, lineHeight: 1.2 }}>
          {title}
        </Typography>
        {subtitle && <Typography sx={{ fontSize: 13.5, color: MUTED, mt: 0.5 }}>{subtitle}</Typography>}
      </Box>
      {children && <Box sx={{ display: 'flex', alignItems: 'center', alignSelf: 'center', gap: 1, flexWrap: 'wrap' }}>{children}</Box>}
    </Box>
  );
}
